export default "__VITE_PUBLIC_ASSET__cf5ae17a__"